import customHeaders, { getSpace } from '../../common/headers';
import { useParams, useSearchParams } from 'react-router-dom';
import { useDataTable } from '../../common/hooks';
import { FilterContainer } from '../../components/FilterContainer/FilterContainer';
import { useState, useEffect, useRef } from 'react';
import { fetchApiFilterVer3 } from '../../common/filtersFunc';
import {
    TableBox,
    DropDownSelector,
    RangeBox,
    Tabs
} from '@lk-gtcom/ecomlab-components';
import { CardMetricV1 } from '../../components/CardsComponents/CardMetricV1/CardMetricV1';
import useGeneralStore from '../../store/general';
import './LowHighAnalysis.scss';
import { TitlePage } from '../../components/TitlePage/TitlePage';
import { periodWeek } from '../../common/constant';
import { useSavedFilters } from '../../common/useSavedFilters';

const btn_tab = [
    { label: 'По товару', value: 'product' },
    { label: 'По категории', value: 'category' },
    { label: 'По бренду', value: 'brand' }
];

const options_prop = [
    { label: 'Ozon', value: 1 },
    { label: 'Wildberries', value: 3 },
    { label: 'Yandex', value: 2 },
];

const listMetricsLowHigh = [
    'conversion_high_views_high',
    'conversion_high_views_low',
    'conversion_low_views_high',
    'conversion_low_views_low',
    'without_sales'
]

const LowHighAnalysis = () => {
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };
      // Сохранённые фильтры: подставляются в URL при заходе, запись по кнопке
  const { isReady, saveFilters, clearSavedFilters, isSaved, hasSavedFilters } = useSavedFilters(selectedSpace?.value, 'low-high-analysis');
    const [pageValue, setPageValue] = useState('all');
    const [searchParams, setSearchParams] = useSearchParams();

    const [apiData, setApiData] = useState([]);
    const [categoryData, setCategoryData] = useState([]);
    const [brandData, setBrandData] = useState([]);
    const [summaryData, setSummaryData] = useState([]);
    const [advCampaignData, setAdvCampaignData] = useState([]);

    const [selectedMarketplace, setSelectedMarketplace] = useState([]);
    const [selectedApi, setSelectedApi] = useState([{ label: 'Все', value: 'all' }]);
    const [selectedCategory, setSelectedCategory] = useState([]);
    const [selectedBrand, setSelectedBrand] = useState([]);
    const [selectedAdvCampaign, setSelectedAdvCampaign] = useState([]);
    const [selectedSummary, setSelectedSummary] = useState([]);

    const [apiPage, setApiPage] = useState(1);
    const [categoryPage, setCategoryPage] = useState(1);
    const [brandPage, setBrandPage] = useState(1);
    const [advCampaignPage, setAdvCampaignPage] = useState(1);
    const [summaryPage, setSummaryPage] = useState(1);


    const [apiQuery, setApiQuery] = useState('');
    const [categoryQuery, setCategoryQuery] = useState('');
    const [brandQuery, setBrandQuery] = useState('');
    const [advCampaignQuery, setAdvCampaignQuery] = useState('');
    const [summaryQuery, setSummaryQuery] = useState('');

    const [date, setDate] = useState(periodWeek());
    const [dateFrom, dateTo] = date;
    const [isDisabledBtn, setIsDisabledBtn] = useState(true);

    // Карточки
    const [metricCardList, setMetricCardList] = useState([])

    const [tableUrl, setTableUrl] = useState('');
    const [tableBody, setTableBody] = useState(null);

    const paginatorRef = useRef();
    const [setTable, tableProps, setTableFuncs] = useDataTable(
        paginatorRef.current?.setTotal,
        paginatorRef
    );
    const { setLoading, setFetchedData, setHeaders, setSort } = setTableFuncs;
    const [checkedProducts, setCheckedProducts] = useState([]);

    const activeTab = useParams()['*'];

    const fetchTableData = (params, abortController = new AbortController()) => {

        // setLoading(true);

        // let sort, filters;
        // if (params) {
        //     [sort, filters] = params;
        // }

        // const url = `${OlegHttps}/api/v2/marketing/table/products_in_campaign_participate_items${sort?.length > 0
        //     ? '?order_param=' + sort[0] + '&order_param_direction=' + sort[1]
        //     : ''
        //     }`;

        // let api_id_list;
        // let brand_id_list;
        // let category_id_list;
        // let campaign_id_list;

        // if (selectedApi?.length > 0) {
        //     api_id_list = selectedApi?.map((el) => el.value);
        // }

        // if (selectedBrand?.length) {
        //     brand_id_list = selectedBrand.map((el) => el.value);
        // } else {
        //     brand_id_list = ['all'];
        // }

        // if (selectedCategory?.length) {
        //     category_id_list = selectedCategory.map((el) => el.value);
        // } else {
        //     category_id_list = ['all'];
        // }

        // if (selectedAdvCampaign?.length) {
        //     campaign_id_list = selectedAdvCampaign.map((el) => el.value);
        // } else {
        //     campaign_id_list = ['all'];
        // }

        // const [date_from, date_to] = date;

        // const body = JSON.stringify({
        //     offer_id_list: ['all'],
        //     filters: filters || [],
        //     category_id_list: category_id_list,
        //     brand_id_list: brand_id_list,
        //     api_id_list: api_id_list,
        //     campaign_id_list: campaign_id_list,
        //     date_from: msToLocalDate(date_from),
        //     date_to: msToLocalDate(date_to),
        //     order_param: sort?.[0],
        //     order_param_direction: sort?.[1],
        //     page: paginatorRef.current?.page || 0,
        //     limit: paginatorRef.current?.limit || 10,
        // });

        // fetch(url, {
        //     method: 'POST',
        //     headers,
        //     body,
        //     signal: abortController.signal,
        // })
        //     .then(async (res) => {
        //         if (res.ok) {
        //             return res.json();
        //         } else {
        //             const err = await res.json();
        //             throw new Error(JSON.stringify(err));
        //         }
        //     })
        //     .then((json) => {
        //         setTable(json);
        //         setTableUrl(url);
        //         setTableBody(body);
        //     })
        //     .catch((e) => console.error(e))
        //     .finally(() => {
        //         if (abortController.signal.aborted) return;
        //         setLoading(false);
        //     });
    };

    useEffect(() => {
        setPageValue(activeTab);
        const campaignName = searchParams.get('campaignName');
        const campaignId = searchParams.get('campaignId');
        const apiName = searchParams.get('apiName');
        const apiId = searchParams.get('apiId');
        if (
            (campaignName?.length > 0) &
            (campaignId?.length > 0) &
            (apiName?.length > 0) &
            (apiId?.length > 0)
        ) {
            setSelectedAdvCampaign([{ label: campaignName, value: campaignId }]);
            setSelectedApi([{ label: apiName, value: apiId }]);
        }
    }, [activeTab]);

    useEffect(() => {
        if (
            selectedApi.length > 0 &&
            selectedCategory.length > 0 &&
            selectedBrand.length > 0
        ) {
            setIsDisabledBtn(false);
        } else setIsDisabledBtn(true);
    }, [selectedApi, selectedCategory, selectedBrand]);

    const apiFilter = () => {
        fetchApiFilterVer3({
            selectedSpace: selectedSpace?.value,
            page: apiPage,
            set: setApiData,
            searchParam: apiQuery,
            filter: 'api_id',
        });
    }

    useEffect(() => {
        apiFilter()
    }, [apiPage, apiQuery]);

    const categoryFilter = () => {
        fetchApiFilterVer3({
            selectedSpace: selectedSpace?.value,
            page: categoryPage,
            selectedApi,
            set: setCategoryData,
            searchParam: categoryQuery,
            filter: 'category',
        });
    }

    useEffect(() => {
        categoryFilter()
    }, [categoryPage, categoryQuery]);

    const brandFilter = () => {
        fetchApiFilterVer3({
            selectedSpace: selectedSpace?.value,
            selectedApi,
            selectedCategory,
            page: brandPage,
            searchParam: brandQuery,
            selectedShop: selectedMarketplace,
            set: setBrandData,
            filter: 'brand',
        });
    }

    useEffect(() => {
        brandFilter()
    }, [brandPage, brandQuery]);


    useEffect(() => {
        fetchTableData([]);
    }, [date]);

    return (
        <div className="low-high-analysis">
            <TitlePage
                title='Low-high анализ'
            />

            <div className="low-high-analysis__filters">
                <FilterContainer
                    onReset={(e) => {
                        setSelectedMarketplace([])
                        setSelectedApi([]);
                        setSelectedCategory([]);
                        setSelectedBrand([]);
                        setSelectedSummary([])
                    }}
                >
                    <DropDownSelector
                        options_prop={options_prop}
                        state={selectedMarketplace}
                        setState={(e) => setSelectedMarketplace(e)}
                        placeholder="Маркетплейс"
                        defaultValue={[{ label: 'Все', value: 'all' }]}
                        multi
                        onBlur={() => {
                            apiFilter()
                            brandFilter()
                            categoryFilter()
                            fetchTableData()
                        }}
                    />

                    <DropDownSelector
                        options_prop={apiData}
                        state={selectedApi}
                        setState={setSelectedApi}
                        placeholder="Площадка"
                        fetchCallback={setApiPage}
                        setInputChange={setApiQuery}
                        multi
                        onBlur={() => {
                            brandFilter()
                            categoryFilter()
                            fetchTableData()
                        }}
                    />

                    <DropDownSelector
                        options_prop={categoryData}
                        state={selectedCategory}
                        setState={setSelectedCategory}
                        placeholder="Категория"
                        fetchCallback={setCategoryPage}
                        setInputChange={setCategoryQuery}
                        defaultValue={[{ label: 'Все', value: 'all' }]}
                        multi
                        onBlur={() => {
                            brandFilter()
                            fetchTableData()
                        }}
                    />

                    <DropDownSelector
                        options_prop={brandData}
                        state={selectedBrand}
                        setState={setSelectedBrand}
                        placeholder="Бренд"
                        fetchCallback={setBrandPage}
                        setInputChange={setBrandQuery}
                        defaultValue={[{ label: 'Все', value: 'all' }]}
                        multi
                        onBlur={() => {
                            fetchTableData()
                        }}
                    />

                    <DropDownSelector
                        options_prop={summaryData}
                        state={selectedSummary}
                        setState={(e) => setSelectedSummary(e)}
                        placeholder="По сумарным данным"
                        fetchCallback={(e) => setSummaryPage(e)}
                        setInputChange={(e) => setSummaryQuery(e)}
                        defaultValue={[{ label: 'Все', value: 'all' }]}
                        multi
                    />
                </FilterContainer>

                <RangeBox
                    date={date} setDate={(e) => setDate(e)} btn_period={false} />
            </div>

            <div className='analytics-page__metrics-list'>
                {metricCardList?.length ?
                    metricCardList?.map(({ labels, data }, ind) => {
                        return <CardMetricV1
                            label={listMetricsLowHigh?.[ind]}
                            key={labels?.title + ind + metricCardList?.length}
                            header={labels?.header}
                            data={data}
                            title={labels?.title}
                        />
                    }).slice(0, 5)
                    :
                    [...Array(5)]?.map((el, ind) => {
                        return <CardMetricV1
                            key={ind}
                            header={[]}
                            data={[]}
                            title={'-'}
                        />
                    })
                }
            </div>

            <Tabs tabs={btn_tab} pageValue={pageValue} />

            <TableBox
                {...tableProps}
                paginator={true}
                ref={paginatorRef}
                onCheck={(e) => setCheckedProducts(e)}
                fetchCallback={(e) => fetchTableData(e)}
                tableUrl={tableUrl}
                tableBody={tableBody}
            />
        </div>
    );
};

export { LowHighAnalysis };
